"use strict";

import angular from "angular";

import template from "./chip.component.html";
import "./chip.component.scss";

class ChipComponent {
    constructor() {}

    $onInit() {}

    beforeRemove() {
        this.onRemove();
    }
}

ChipComponent.$inject = [];

const component = {
    bindings: {
        onRemove: "&"
    },
    transclude: true,
    controller: ChipComponent
};

const name = "chipComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
